import { CademyError } from '@shared/domain-shared';

export class GeneralSearchError extends CademyError {
    constructor(detail = 'An unknown error occurred while performing the search') {
        super('search/general', 'An error occurred while searching', detail, 500);
    }
}
